import styled from 'styled-components';
// old design
export const Table = styled.table `
  border-collapse: collapse;
  //border: 1px solid grey;
  font-size: 1.5rem;
  width: 100%;
`;
// new design
export const TableNew = styled.table `
  border-collapse: collapse;
  font-size: 1.5rem;
  max-width: 708px;
  border: 4px solid #ffffff;
  border-radius: 24px;
  display: block;
  overflow: hidden;
  backdrop-filter: blur(14px);
`;
export const TableModal = styled.table `
  border-collapse: collapse;
  border: none;
  display: block;
`;
